import { fetchService } from './fetchService';
// import baseUrl from '../authConfig';
interface TokenValidationResult {
  isValid: boolean;
  userIdValid: boolean;
  teamAccess: boolean;
  orgAccess: boolean;
  tokenvalidity: boolean;
  message: string;
}

export const validateGitHubToken = async (
  token: string,
  teamName: string,
  userName: string
): Promise<TokenValidationResult> => {

  try {
    const data = await fetchService<TokenValidationResult>(
      `github/validate-token`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: {
          token: token,
          team_name: teamName,
          user_name: userName,
        },
      }
    );


    return {
      isValid: data.isValid,
      userIdValid: data.userIdValid,
      teamAccess: data.teamAccess,
      orgAccess: data.orgAccess,
      tokenvalidity: data.tokenvalidity,
      message: data.message,
    };
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Network response was not ok: ${error.message}`);
    } else {
      throw new Error('An unknown error occurred');
    }
  }
};
